export enum UnRegisterContractAction {
  GET_SKUsOPTIONS = "GET_UNREGISTER_SKUsOPTIONS",
  SET_SKUsOPTIONS = "SET_UNREGISTER_SKUsOPTIONS",
  CREATE_UNREGISTER_CONTRACT = "CREATE_UNREGISTER_CONTRACT",
  CLEAN_UP = "UNREGISTER_CONTRACT_STATE_CLEAN_UP",
  UPLOAD_DOCUMENTS = "UNREGISTER_UPLOAD_DOCUMENTS",
  SET_UPLOADED_DOCUMENTS = "UNREGISTER_SET_UPLOADED_DOCUMENTS",
}

export interface UnRegisterState {
  sku: [];
  data: CreateUnRegisterContract;
}

export interface CreateUnRegisterContract {
  invoicenumber: string;
  protectallSku: string;
  recordType: string;
  contractRetailPrice: string;
  totalProductRetailValue: string;
  customerId: string;
  customerFirstName: string;
  customerLastName: string;
  customerEmail: string;
  customerPrimaryTelephone: string;
  customerAlternativeTelephone: string;
  customerStreetAddress1: string;
  customerStreetAddress2: string;
  customerCity: string;
  customerState: string;
  customerPostalCode: string;
  customerCountryCode: string;
  customerDeliveryStreetAddress1: string;
  customerDeliveryStreetAddress2: string;
  customerDeliveryCity: string;
  customerDeliveryState: string;
  customerDeliveryPostalCode: string;
  customerDeliveryCountryCode: string;
  sellingStoreCode: string;
  sellingStoreLocation: string;
  sellingStoreAddress: string;
  sellingStoreCity: string;
  sellingStoreState: string;
  sellingStorePostalCode: string;
  sellingStoreCountryCode: string;
  contractPurchaseDate: Date | null;
  deliveryDate: Date | null;
  salesPersonId: string;
  referenceNumber: string;
  documents: string[];
  productLineItems: LineItems[];
}

export interface LineItems {
  manufacturer: string;
  modelNumber: string;
  serialNumber: string;
  purchaseDateOfProduct: Date | null;
  deliveryDateOfProduct: Date | null;
  productRetailPrice: string;
  quantity: string;
  productQuality: string;
  productSku: string;
  productDescription: string;
}

export type ActionType = {
  type: string;
  payload?: any;
};

export const UnRegisterScope = "unRegister";
